import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const FactoryIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M17 17a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2h-1Zm-6 1c0-.6.4-1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1Zm-4-1a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2H7Z" />
      <path
        fillRule="evenodd"
        d="M4 1a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V8a1 1 0 0 0-1.6-.8L16 11V8a1 1 0 0 0-1.6-.8L9 11V4a3 3 0 0 0-3-3H4Zm-.7 2.3c.2-.2.4-.3.7-.3h2a1 1 0 0 1 1 1v9a1 1 0 0 0 1.6.8L14 10v3a1 1 0 0 0 1.6.8L21 10v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4c0-.3.1-.5.3-.7Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default FactoryIcon;
